import { render, staticRenderFns } from "./LangsAddNew.vue?vue&type=template&id=4cadddcc"
import script from "./LangsAddNew.vue?vue&type=script&lang=js"
export * from "./LangsAddNew.vue?vue&type=script&lang=js"
import style0 from "./LangsAddNew.vue?vue&type=style&index=0&id=4cadddcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports